
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2020/07/covid-search-data",
      function () {
        return require("private-next-pages/blog-post/2020/07/covid-search-data.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2020/07/covid-search-data"])
      });
    }
  